/**
 * Updated by tubo.io on 2019/04/07.
 *
 * 所有页面的配置文件
 */

const setup =  {
  baiduAk: 'UoEDI9ByuVPtlkSnci2UZIEM',
  mapCenter: '杭州市',

  menu: [
    {title: '用户信息', url: 'custom/center'},
    {title: '办理指南', url: 'custom/help'},
    {title: '政府送章', url: 'custom/state', actOn: 'state'},
    {title: '新企业联办', url: 'custom/samr/list', actOn: 'samr'},
    {title: '零接触刻章', url: 'custom/order/current', actOn: 'seal'},
    {title: '免费刻章预约', url: 'custom/reservation/pages', actOn: 'free'},
    // 三所电子印章预约
    {title: '电子印章申请', url: 'custom/dz/commonCurrent', actOn: 'dzCommon'},
    // 河南电子印章
    {title: '电子印章申请', url: 'custom/dz/henanList', actOn: 'dzHenan'},
  ],

  pages: [
    {title: '新增订单', url: 'custom/order/new', actOn: 'seal'},
    {title: '订单详情', url: 'custom/order/show', actOn: 'seal'},
    {title: '电子公章登记', url: 'custom/dz/commonNew', actOn: 'dzCommon'},
    {title: '电子公章详情', url: 'custom/dz/commonInfo', actOn: 'dzCommon'},
    {title: '门店办理', url: 'custom/samr/offline', actOn: 'seal'},
    {title: '免费刻章预约', url: 'custom/reservation/new', actOn: 'reservation'},
    {title: '预约成功', url: 'custom/reservation/success', actOn: 'reservation'},
    {title: '电子公章登记', url: 'custom/dz/henanNew', actOn: 'dzHenan'},
    {title: '公章刻制联办', url: 'samr/haikou', actOn: 'seal'},
    // {title: '公章刻制联办', url: 'samr/hangzhou', actOn: 'seal'},
    // {title: '公章刻制联办-数据同步中', url: 'samr/samr-not-sync', actOn: 'seal'},
  ],

  // 根据服务器端传过来的权限actOn来对pages进行过滤
  rightsFilter(config, actOn) {
    return {
      menu: config.menu.filter(item => !item.actOn || actOn.indexOf(item.actOn) > -1),
      pages: config.pages.filter(item => !item.actOn || actOn.indexOf(item.actOn) > -1)
    }
  },

  // 动态创建路由, config=子项目的配置对象, actOn=服务器传递过来的权限, views=自路由页面的根路径, frame=框架的相对路径
  createRouter(config, actOn, frame) {
    let rights = this.rightsFilter(config, actOn);

    // 框架路由
    let route = {
      path: '/',
      component: (resolve) => require(['../views/frame/frame.vue'], resolve)
    }

    // 菜单页面
    route.children = rights.menu.map(item => {
      return {
        path: item.url,
        meta: {title: item.title},
        component: (resolve) => require(['../views/' + item.url + '.vue'], resolve)
      }
    })

    // 不在菜单里面的其它页面
    rights.pages && rights.pages.map(item => {
      if (item.url) {
        route.children.push({
          path: item.url,
          meta: {title: item.title},
          component: (resolve) => require(['../views/' + item.url + '.vue'], resolve)
        })
      }
    })

    return [route]
  },
}

export default setup
